import { Box, Divider, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../components/Buttons/BackButton';
import VisitorFormStepsEdit from '../components/FormContainers/CreateUserForm/VisitorFormStepsEdit';
import FormSkeleton from '../components/Skeletons/FormSkeleton';
import { IntExt } from '../lib/permissions';
import HttpService from '../services/HttpService';
import UserService from '../services/UserService';
import Theme from '../Themes/main.theme';
import { FormikContextType } from 'formik';

export interface IVisitorForm {
  id: number | null;
  full_name: string;
  email: string;
  phone_number: string;
  auth: string;
  username: string;
  nomiki: boolean;
  category: { key: string, value: number }[]
}

const EditVisitor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState<
    { key: string; value: number }[]
  >([]);

  const is_internal = UserService.hasRole([IntExt.Internal]);

  document.title = t('Επεξεργασία Χρήστη');

  const [data, setData] = useState<IVisitorForm>({
    id: null,
    full_name: '',
    email: '',
    phone_number: '',
    auth: '',
    username: '',
    nomiki: false,
    category: []
  });

  const getData = async () => {
    try {
      const response = id
        ? await HttpService.getAxiosClient().get(
          `${process.env.REACT_APP_BACKEND_URL}/users/${id}`
        )
        : await HttpService.getAxiosClient().get(
          `${process.env.REACT_APP_BACKEND_URL}/users/user`
        );
      is_internal
        ? setData({
          ...response.data,
          roles: response.data.roles.map((x: any) => {
            return {
              key: x.name,
              value: x.id,
            };
          }),
          category: response.data.category.map((category: any) => {
            return {
              key: category.description,
              value: category.id,
            };
          })
        })
        : setData(response.data);

      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getCategoryOptions = async () => {
    const response = await HttpService.getAxiosClient().get(
      `${process.env.REACT_APP_BACKEND_URL}/users-parametrics/categories`
    );
    setCategoryOptions(response.data.categories);
  };

  useEffect(() => {
    getData();
    is_internal && getCategoryOptions();
  }, []);

  const onSubmit = async (values: FormikContextType<any>) => {
    setIsSubmitLoading(true);

    const touched_values = {};
    Object.keys(values.touched).map((value: any) => {
      Object.assign(touched_values, { [value]: values.values[value] });
    });

    const visitor_id = id || data.id;
    try {
      if (is_internal) {

        await HttpService.getAxiosClient().patch(
          `${process.env.REACT_APP_BACKEND_URL}/users/${visitor_id}`, touched_values
        );
        navigate(`/admin/visitor/${visitor_id}`),
        enqueueSnackbar('Επιτυχής Επεξεργασία του Χρήστη', { variant: 'success' });
      }

      else {
        await HttpService.getAxiosClient().patch(
          `${process.env.REACT_APP_BACKEND_URL}/users`, touched_values
        );

        navigate('/profile');
        enqueueSnackbar('Επιτυχής Επεξεργασία των στοιχείων σας', { variant: 'success' });
      }

    } catch (error) {
      enqueueSnackbar(
        'Η Επεξεργασία των στοιχείων σας απέτυχε, παρακαλώ προσπαθήστε ξανά!', { variant: 'error' }
      );
      console.error(error);
    }
    setIsSubmitLoading(false);
  };

  return (
    <>
   
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigate(-1)} />
      </Box>
      <Typography sx={{ my: 2 }} variant='h2'
        color={Theme?.labelColor?.main}>
        {t('Επεξεργασία Χρήστη')}
      </Typography>
      <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
      {!isLoading
        ? (
          <VisitorFormStepsEdit
            {...(is_internal && { categoryOptions: categoryOptions })}
            initialValues={data}
            onSubmit={onSubmit}
            isSubmitLoading={isSubmitLoading}
          />
        )
        : (
          <FormSkeleton lines={5} />
        )}
    </>
  );
};

export default EditVisitor;
